const rawBase = process.env.VUE_APP_API_URL || '';
const API_BASE_URL = rawBase.replace(/\/+$/, '') + '/';

export default {
    base: API_BASE_URL,
    getAccommodation: `${API_BASE_URL}accommodations/getAccomodation/`,
    reservations: `${API_BASE_URL}reservations`,
    getReceivedReservations: `${API_BASE_URL}reservations/received`,
    setReservationAsPaid: `${API_BASE_URL}pago/manualpayment`,
    searchAccommodations: `${API_BASE_URL}search_alojamiento`,
    icalUrl: `${API_BASE_URL}ical/url`,
    icalBatch: `${API_BASE_URL}ical/batch`,
    syncWithExternalIcal: `${API_BASE_URL}ical/sync-with-external-ical`,
    bankData: `${API_BASE_URL}bank-data`,
    contact: `${API_BASE_URL}contact`,
    contactForm: `${API_BASE_URL}contact-form`,
    recaptcha: `${API_BASE_URL}recaptcha/contact`,
    simulation: `${API_BASE_URL}simulation`,
    available: `${API_BASE_URL}available`,
    userType: `${API_BASE_URL}users/type`,
    userCountry: `${API_BASE_URL}users/country`,
    userUpdatePhone: `${API_BASE_URL}users/update-phone`,
    // Verificación del teléfono por WhatsApp en el registro
    userTelefonoValidar: `${API_BASE_URL}users/telefono/validar`,
    userCodigoWspEnviar: `${API_BASE_URL}users/codigo-wsp/enviar`,
    userCodigoWspVerificar: `${API_BASE_URL}users/codigo-wsp/verificar`,
    conversations: `${API_BASE_URL}conversations`,
    conversationsFromVisit: `${API_BASE_URL}conversations/from-visit`,
    conversationsFromVisitHost: `${API_BASE_URL}conversations/from-visit-host`,
    conversationsSupport: `${API_BASE_URL}support/conversations`,
    conversationsAdmin: `${API_BASE_URL}admin/get-conversations`,
    messages: `${API_BASE_URL}messages`,
    messagesAdmin: `${API_BASE_URL}admin/get-messages`,
    n8nBotWebhook: `${API_BASE_URL}bot/verify-phone`,
    n8nBotSendClient: `${API_BASE_URL}bot/send-client`,
    notifyConversation: `${API_BASE_URL}conversations/notify`,
    // Admin share links endpoints
    adminLinks: `${API_BASE_URL}admin/links`,
    adminPermissions: `${API_BASE_URL}admin/permissions/admins`,
    // Bulk price update endpoints (admin)
    bulkPricePreview: `${API_BASE_URL}admin/accommodations/bulk-price-preview`,
    bulkPriceUpdate: `${API_BASE_URL}admin/accommodations/bulk-price-update`,
    // Dashboard
    dashboardAccommodations: `${API_BASE_URL}dashboard/accommodations`,
    accommodationsApprovedAll: `${API_BASE_URL}accommodations/approved`,
    accommodationsWaitingAll: `${API_BASE_URL}accommodations/waiting`,
    accommodationsEliminatedAll: `${API_BASE_URL}accommodations/eliminated`,
    dashboardStats: `${API_BASE_URL}dashboard/stats`,
    dashboardHostsResponseTime: `${API_BASE_URL}dashboard/hosts/response-time`,
    dashboardHostsAccommodationCount: `${API_BASE_URL}dashboard/hosts/accommodations-count`,
    // Intakes que coinciden con un teléfono (enlace reserva ↔ intake)
    dashboardIntakeByPhone: (phone) => `${API_BASE_URL}dashboard/intakes/by-phone/${encodeURIComponent(phone)}`,
    // Admin → Usuarios (AdminUsuariosController)
    adminUsuarios: `${API_BASE_URL}admin/usuarios`,
    adminUsuario: (id) => `${API_BASE_URL}admin/usuarios/${encodeURIComponent(id)}`,
    adminUsuarioAccion: (id, accion) => `${API_BASE_URL}admin/usuarios/${encodeURIComponent(id)}/${accion}`,
    adminFindUser: `${API_BASE_URL}admin/find-user`,
    adminExportAccommodationsByUser: `${API_BASE_URL}admin/accommodations/by-user/`,
    adminVerifyAccommodations: `${API_BASE_URL}verify-accommodations`,
    getMultipleAccommodations: `${API_BASE_URL}accommodations/get-multiple-accommodations`,
    
    // Mensajería admin — popups
    adminClientes:    `${API_BASE_URL}clientes`,
    adminAnfitriones: `${API_BASE_URL}anfitriones`,
    adminAlojamientos: `${API_BASE_URL}alojamientos`,
    securityDeposit: (id) => `${API_BASE_URL}reservations/${id}/security-deposit`,
    // BackOffice
    backofficeInventory: `${API_BASE_URL}backoffice/inventory`,
    // Valores posibles de una columna, para su menú de filtro: con el listado
    // paginado el front ya no tiene el inventario entero de donde sacarlos.
    backofficeInventoryFacets: `${API_BASE_URL}backoffice/inventory/facets`,
    backofficeHosts:     `${API_BASE_URL}backoffice/hosts`,
    backofficeHostRating: `${API_BASE_URL}backoffice/hosts/rating`,
    backofficeHostWhatsappGroup: `${API_BASE_URL}backoffice/hosts/whatsapp-group`,
    // Edición de datos del anfitrión desde el back office (solo superadmins)
    backofficeUpdateHostProfile: (id) => `${API_BASE_URL}backoffice/hosts/${id}/profile`,
    backofficeUpdateHostBankData: (id) => `${API_BASE_URL}backoffice/hosts/${id}/bank-data`,
    countries: `${API_BASE_URL}countries`,
    backofficeGalerias:  `${API_BASE_URL}backoffice/galerias`,
    backofficeExchange:  `${API_BASE_URL}backoffice/exchange`,
    backofficeLocations: `${API_BASE_URL}backoffice/locations`,
    // Aprobar / eliminar (lógico) desde las secciones Sin aprobar y Eliminados
    backofficeApproveAccommodations: `${API_BASE_URL}backoffice/accommodations/approve`,
    backofficeDeleteAccommodations:  `${API_BASE_URL}backoffice/accommodations/delete`,
    // Herramientas de admin en la ficha del alojamiento
    backofficeAccommodationStatus: (id) => `${API_BASE_URL}backoffice/accommodations/${id}/estado`,
    backofficeAccommodationData:   (id) => `${API_BASE_URL}backoffice/accommodations/${id}/datos`,
    backofficeAccommodationScope:  (id) => `${API_BASE_URL}backoffice/accommodations/${id}/alcance`,
    backofficeAccommodationImages: (id) => `${API_BASE_URL}backoffice/accommodations/${id}/imagenes`,
    // Cambio de teléfono verificado por WhatsApp (Editar perfil)
    telefonoCambioIniciar:   `${API_BASE_URL}users/telefono-cambio/iniciar`,
    telefonoCambioReenviar:  `${API_BASE_URL}users/telefono-cambio/reenviar`,
    telefonoCambioVerificar: `${API_BASE_URL}users/telefono-cambio/verificar`,
    telefonoCambioCancelar:  `${API_BASE_URL}users/telefono-cambio/cancelar`,
    backofficeSendBulkEmail: `${API_BASE_URL}admin/backoffice/send-bulk-email`,
    // Importación Homiii (eliminada)

    // Panel del usuario tipo property
    propertyCalendar: `${API_BASE_URL}property/calendario`,
    informes: `${API_BASE_URL}informes`,
    informeDownload: (id) => `${API_BASE_URL}informes/${id}/descargar`,
    // Admin de informes (carga de archivos por usuario)
    adminInformes: `${API_BASE_URL}admin/informes`,
    adminInformesUsuarios: `${API_BASE_URL}admin/informes/usuarios`,
    adminInformeDelete: (id) => `${API_BASE_URL}admin/informes/${id}`,
    // PUT: mover de carpeta (periodo) o de categoría
    adminInformeUpdate: (id) => `${API_BASE_URL}admin/informes/${id}`,
}
